<template>
  <div class="card-review-gate">
    <div class="g-title">{{ payload.reason || '成品在这儿，看看还要不要改' }}</div>
    <div class="g-sub">改文案只重渲受影响的那几页，<b>不扣点</b></div>

    <!-- ★图必须摆在这儿：这一屏是让用户"看着成品拍板"，
         没有图的话这个闸门等于让人凭空判断 -->
    <div v-if="pages.length" class="shots">
      <div v-for="p in pages" :key="p.index" class="shot">
        <el-image
          v-if="p.url"
          :src="p.url"
          fit="cover"
          class="img"
          :preview-src-list="previewList"
          :initial-index="previewList.indexOf(p.url)"
        />
        <!-- 单页上传失败时不留一块空白让人以为坏了 -->
        <div v-else class="img broken">
          <i class="el-icon-picture-outline"></i>
          <span>这页预览没取到</span>
        </div>
        <div class="cap">
          <span class="idx">{{ String(p.index).padStart(2, '0') }}</span>
          <span class="h" :title="p.headline">{{ p.headline || '（纯图页）' }}</span>
        </div>
        <div v-if="p.overflow" class="of">文字偏多，可能被裁</div>
      </div>
    </div>

    <div v-if="!editing" class="btns">
      <el-button type="primary" size="small" :loading="submitting" @click="$emit('submit', { action: 'accept' })">
        就这样，定稿
      </el-button>
      <el-button size="small" :disabled="submitting" @click="editing = true">改改</el-button>
    </div>

    <div v-else class="edit-box">
      <el-input
        v-model="instruction"
        type="textarea"
        :rows="2"
        placeholder="想改哪里？例如：第3页标题短一点、整体再口语化一些"
      />
      <div class="btns">
        <el-button
          type="primary"
          size="small"
          :loading="submitting"
          :disabled="!instruction.trim()"
          @click="submitEdit"
        >按这个改</el-button>
        <el-button size="small" :disabled="submitting" @click="editing = false">取消</el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CardReviewGate',
  props: {
    payload: { type: Object, required: true },
    submitting: { type: Boolean, default: false },
  },
  data() {
    return { editing: false, instruction: '' }
  },
  computed: {
    pages() {
      return [...(this.payload.preview || [])].sort((a, b) => a.index - b.index)
    },
    /** 点开大图能左右翻整套，而不是只看这一张 */
    previewList() {
      return this.pages.map((p) => p.url).filter(Boolean)
    },
  },
  methods: {
    submitEdit() {
      this.$emit('submit', { action: 'edit', instruction: this.instruction.trim() })
    },
  },
}
</script>

<style lang="scss">
.card-review-gate {
  min-width: 520px;
  .g-title { font-size: 14px; font-weight: 600; color: #1f2329; }
  .g-sub { margin-top: 4px; font-size: 12px; color: #8a8f98; b { color: #2aa54a; } }

  .shots {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    margin-top: 12px;
  }
  .shot { width: 108px; }
  .img {
    width: 108px;
    height: 192px;   /* 9:16，跟出图比例一致 */
    border-radius: 8px;
    background: #eef0f4;
    cursor: zoom-in;
  }
  .img.broken {
    display: flex; flex-direction: column; align-items: center; justify-content: center;
    gap: 6px; color: #b0b4bb; font-size: 12px; cursor: default;
    i { font-size: 20px; }
  }
  .cap {
    margin-top: 5px; display: flex; align-items: baseline; gap: 5px;
    font-size: 12px; line-height: 1.4;
    .idx { color: #b0b4bb; flex-shrink: 0; }
    .h { color: #4e5462; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
  }
  .of { margin-top: 2px; font-size: 11px; color: #f0a020; }

  .edit-box { margin-top: 12px; }
  .btns { margin-top: 14px; display: flex; gap: 8px; }
}
</style>
